import clsx from 'clsx';
import React from 'react';

import ImageCustom from 'commons/ImageCustom';
import Text from 'commons/Text';
import ErrorImage from 'images/error_image.png';

import useStyles from './styles';

const DialogArtwortInfo = ({ artwork }) => {
  const classes = useStyles();

  const { artist_tag_request, artist_artwork } = artwork || {};

  const { request_to } = artist_tag_request || {};

  const getTextArtistName = () => {
    if (!artist_artwork?.artist_name && !request_to?.id) {
      return 'N/A';
    }

    if (request_to?.id) {
      return request_to?.name;
    }

    return artist_artwork?.artist_name;
  };

  return (
    <div className={classes.artworkInfoWrapper}>
      <ImageCustom
        src={artwork?.images?.[0]}
        imageStyle={classes.image}
        loadingStyle={classes.loadingImage}
        iconLoadingStyle={classes.iconImage}
        errorStyle={classes.errorStyle}
        customeError={
          <img
            src={ErrorImage}
            alt="Error image"
            className={clsx(classes.imageError, classes.image)}
          />
        }
      />

      <div>
        <Text
          type="lg"
          className={classes.artworkTitle}
          fontWeightMedium
        >
          {artwork?.title}
        </Text>

        <Text
          type="xs"
          className={classes.artworkArtist}
        >
          {getTextArtistName()}
        </Text>
      </div>
    </div>
  );
};

export default DialogArtwortInfo;
